import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/page.tsx");
